//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "BoolSelect",
  props: {
    label: {
      type: String
    },
    outlined: {
      type: Boolean,
      default: true
    },
    filled: {
      type: Boolean
    },
    required: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
    optionsDense: {
      type: Boolean,
      default: true
    },
    hint: {
      type: String
    },
    value: null,
    inputStyle: {
      type: String,
      default: "width:75px"
    },
    binaryOptions: {
      type: Boolean,
      default: false
    },
    options: {},
    rules: {}
  },
  data: function data() {
    return {
      originalValue: null
    };
  },
  mounted: function mounted() {
    this.originalValue = this.value;
  },
  methods: {
    isRequired: function isRequired() {
      return !this.required || this.value != null || "Required";
    },
    validate: function validate() {
      return this.$refs.input.validate();
    },
    resetDirty: function resetDirty() {
      this.originalValue = this.value;
    }
  },
  computed: {
    shownOptions: function shownOptions() {
      if (this.options && this.options.length > 0) return this.options;
      if (this.binaryOptions) return [{
        label: "Yes",
        value: 1
      }, {
        label: "No",
        value: 0
      }];
      return [{
        label: "Yes",
        value: true
      }, {
        label: "No",
        value: false
      }];
    },
    isDirty: function isDirty() {
      return this.value != "" && this.value != this.originalValue;
    }
  }
};